import React, {useEffect} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {getDefaultYear, getSelectedYear, selectYear, setBaseGroup} from '../../slices/vehicleSlice';
import './button.scss'
import "../../components/nav/Navbar.scss";
import {useLocation} from "react-router-dom";
import {trackVehicleModelYearSelected} from "../GoogleTagManager.utils";


const YearToggle = ({years,defaultYear}) => {

    function useQuery() {
        const {search} = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let query = useQuery();
    const activeYear = useSelector(getSelectedYear)
    const baseGroup = useSelector(setBaseGroup);
    const dispatch = useDispatch();

    if (query.get('year') !== defaultYear && query.get('year') !== null && years.includes(query.get('year'))) {
        defaultYear = query.get('year')
    }
    const handleButtonClick = (year) => {
        dispatch(selectYear(year));
        trackVehicleModelYearSelected(baseGroup);
    };

    useEffect(() => {
        dispatch(getDefaultYear(defaultYear))
    }, [defaultYear])

    return (
        <React.Fragment>
            <div className={'year-toggle'}>
                {
                    years.map((year, index) => (
                        <button key={index} id={year}
                                onClick={() => handleButtonClick(year)}
                                className={year !== activeYear ? 'btn-default' : 'btn-active'}
                                tabIndex={1}>{year} </button>
                    ))
                }
            </div>
        </React.Fragment>
    )
};

export default YearToggle;